export const visit = (vm, at) => {
at({ "fr": { "conversationsVisitorUIPageTitleNotifications": { "newMessage": "Nouveau message" } } });
};